<template>
    <div v-if="!totalError" class="w-full max-w-30rem">
        <div class="w-full flex flex-column mb-4">
            <span class="text-color-secondary">{{ lang('type_amount') }}: </span>
            <SelectButton v-model="amountType" :options="amountTypes" optionLabel="title" optionValue="code"  dataKey="title"  class="mt-2 border-round-xl">
                <template #option="slotProps">
                    <span class="text-sm p-1">{{ slotProps.option.title[lang_] }}</span>
                </template>
            </SelectButton>
        </div>

        <!--AMOUNT TO RECEIVE-->
        <div v-if="currencies && loaded" class="w-full">
            <span class="text-color-secondary">{{ lang('amount_receive') }}: </span>
            <div class="p-inputgroup w-full cur_drop flex flex-row mt-2 mb-3">
                <InputNumber v-if="amountType=='recipient'"
                    placeholder="Сумма счета" v-model="amount_send" inputId="locale-us"
                    class="p-inputtext-lg flex w-full border-2 border-round-lg surface-border amount_input"
                    :min-fraction-digits="0" :max-fraction-digits="2" :min="min_limit" :max="max_limit" />

                <InputText v-else :placeholder="lang('any_amount')"
                    class="p-inputtext-lg flex w-full border-2 border-round-lg surface-border amount_input" :disabled="true" />

                <span class="flex p-inputgroup-addon p-0 border-2 surface-border">
                    <Dropdown id='currency' v-model="currency_choosen" :options="currencies"
                        option-label="name" class='border-none border-round-right-lg w-9rem p-inputtext-lg'
                        placeholder="Выбрать валюту">
                        <template #value="slotProps">
                            <div v-if="slotProps.value" class="flex align-items-center h-full">
                                <Avatar :image="getCurImage(slotProps.value)" shape="circle" class="mr-2 border-200 border-1"/>
                                <div class="text-sm font-medium uppercase" style="width:2em">{{ slotProps.value.code }}</div>
                            </div>
                            <span v-else class="flex align-items-center h-full text-sm font-medium">
                                {{ slotProps.placeholder }}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <div class="flex align-items-center w-7rem">
                                <img :src="getCurImage(slotProps.option)" :alt="slotProps.option.label" class="mr-2 w-3 border-200 border-1 border-circle" />
                                <div class="text-sm font-medium uppercase">{{ slotProps.option.code }}</div>
                            </div>
                        </template>
                    </Dropdown>

                </span>
            </div>
        </div>
        <Skeleton v-else height="3rem" class="mt-2 mb-3"/>

        <!--RECIPIENTS-->
        <div v-if="loaded && recipients_allowed && recipient_choosen && !hide_recipients">
            <span class="text-color-secondary">{{ lang('recipient_list') }}:</span>
            <div @click="recipients_popup_show()"
                class="input_banks flex flex-row cursor-pointer relative w-full mt-2 mb-3 py-3 px-2 mb-3 surface-border border-2 border-round-xl justify-content-left align-items-center overflow-hidden gap-2">
                <div class="flex">
                    <AvatarGroup>
                        <Avatar :image="get_bank_image(recipient_choosen.bank_code)" class="w-full surface-0" shape="circle"/>
                    </AvatarGroup>
                </div>
                <div class="flex-1 flex flex-column gap-1 justify-content-center">
                    <div class="w-full relative flex overflow-hidden h-1rem" >
                        <div class="absolute left-0 top-0 font-medium text-sm xl:text-md white-space-nowrap">
                            <span v-if="recipient_choosen.fields && recipient_choosen.fields.fullname" class="mr-1">
                                {{ recipient_choosen.fields.fullname }}
                            </span>
                            <span class="text-500">
                                {{ get_bank_title(recipient_choosen.bank_code) }}
                            </span>
                        </div>
                    </div>
                    <div v-if="recipient_choosen.fields && (recipient_choosen.fields.account_number || recipient_choosen.fields.card_number || recipient_choosen.fields.phone_number || recipient_choosen.fields.telegram || recipient_choosen.fields.wallet_address)"
                        class="flex font-medium text-500 text-sm xl:text-md white-space-nowrap">
                        {{  (recipient_choosen.fields.account_number) ? recipient_choosen.fields.account_number : 
                            (recipient_choosen.fields.card_number) ? formatCardNumber(recipient_choosen.fields.card_number) : 
                            (recipient_choosen.fields.phone_number) ? recipient_choosen.fields.phone_number : 
                            (recipient_choosen.fields.telegram) ? `Tg: ${recipient_choosen.fields.telegram}` : 
                            (recipient_choosen.fields.wallet_address) ? getShort(recipient_choosen.fields.wallet_address, 30) : '' }}
                    </div>
                </div>
                <i class="pi pi-chevron-down text-600 absolute right-0 mr-0 surface-0 p-2 border-circle"></i>
            </div>
        </div>
        <Skeleton v-if="!loaded || !recipients" height="3rem" class="mt-2 mb-3"/>

        <Dialog v-if="loaded && recipients_allowed" v-model:visible="recipients_popup" modal
            class="w-full border-round-xl overflow-hidden border-none surface-100"
            :position="screenSize=='xs' ? 'bottom' : 'center'"
            :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
            :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
            :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

            <template #header>
                <span class="text-lg font-medium">{{ lang('select_recipient') }}</span>
            </template>

            <div class="flex flex-column gap-3 xl:py-4 xl:px-1 lg:py-3 md:py-2">
                <MobMenu :headerTxt="lang('select_recipient')">
                    <template v-slot:body>
                        <div v-for="item of recipients_allowed" @click="choose_recipient(item._id)"
                            class="w-full flex flex-row gap-2 px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:65px">
                            <div class="flex flex-row flex-1 gap-2">
                                <div class="flex">
                                    <AvatarGroup>
                                        <Avatar :image="get_bank_image(item.bank_code)" class="w-full surface-0" shape="circle"/>
                                    </AvatarGroup>
                                </div>
                                <div class="flex-1 flex flex-column gap-1 justify-content-center">
                                    <div class="w-full relative flex overflow-hidden h-1rem" >
                                        <div class="absolute left-0 top-0 font-medium text-sm xl:text-md white-space-nowrap">
                                            <span  v-if="item.fields && item.fields.fullname" class="mr-1">
                                                {{ item.fields.fullname }}
                                            </span>
                                            <span class="text-500">
                                                {{ get_bank_title(item.bank_code) }}
                                            </span>
                                        </div>
                                    </div>
                                    <div v-if="item.fields && (item.fields.account_number || item.fields.card_number || item.fields.phone_number || item.fields.telegram || item.fields.wallet_address)"
                                        class="flex font-medium text-500 text-sm xl:text-md white-space-nowrap">
                                        {{  (item.fields.account_number) ? item.fields.account_number : 
                                            (item.fields.card_number) ? formatCardNumber(item.fields.card_number) : 
                                            (item.fields.phone_number) ? item.phone_number : 
                                            (item.fields.telegram) ? `Tg: ${item.fields.telegram}` : 
                                            (item.fields.wallet_address) ? getShort(item.fields.wallet_address, 30) : '' }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex justify-content-right align-items-center">
                                <i class="pi pi-verified text-600 ml-2 text-primary"></i>
                            </div>
                        </div>
                    </template>
                </MobMenu>
            </div>
        </Dialog>

        <div v-if="loaded && recipient_choosen" class="w-full mb-3">
            <span class="cursor-pointer text-primary" @click="new_recipient(true)">
                <span class="mr-2">{{ lang('create_recipient') }}</span>
                <i class="pi pi-user-plus text-600 mr-2 text-primary"></i>
            </span>
        </div>

        <div v-if="loaded && !recipient_choosen && recipients && recipients.length>0 && recipients_allowed && recipients_allowed.length>0" class="w-full mb-3">
            <span class="cursor-pointer text-primary" @click="new_recipient(false)">
                <span class="mr-2">{{ lang('choose_recipient') }}</span>
                <i class="pi pi-users text-600 mr-2 text-primary"></i>
            </span>
        </div>

        <!--RECIPIENT DATA-->
        <div v-if="loaded && !recipient_choosen">

            <!--BANKS-->
            <span class="text-color-secondary">{{ lang('bank_list') }}:</span>
            <div v-if="loaded && banks_list && bank_choosen" @click="banks_popup_show()"
                class="input_banks flex flex-row cursor-pointer relative w-full mt-2 mb-3 py-3 px-2 mb-3 surface-border border-2 border-round-xl justify-content-left align-items-center">
                <div class="flex w-1">
                    <img :src="bank_choosen.image" class="w-full pr-2">
                </div>
                <span class="flex text-700 text-lg xl:text-xl mr-2">
                    {{ bank_choosen.titles[lang_] }} 
                </span>
                <i class="pi pi-chevron-down text-600 absolute right-0 mr-3"></i>
            </div>

            <Dialog v-model:visible="bank_popup" modal :header="lang('bank_list')" 
                class="w-full ml-2 mr-2 border-round-xl overflow-hidden" style="max-width: 500px;">
                <div v-for="item of banks_list">
                    <div class="flex flex-row cursor-pointer relative px-2 mb-3 surface-border border-2 border-round-lg justify-content-left align-items-center input_banks"
                        @click="choose_bank(item.code)">
                        <div class="flex w-1">
                            <img :src="item.image" class="w-full pr-2">
                        </div>
                        <span class="flex text-700 text-sm xl:text-xl lg:text-lg md:text-md mr-2">
                            {{ item.titles[lang_] }}
                        </span>
                        <div class="absolute right-0 mr-0 surface-0 p-2 border-circle">
                            <div class="surface-border border-1 border-circle" >
                                <div class="border-circle" style="width:18px;height:18px;margin:3px"
                                :class="{'bg-green-400': bank_choosen.code == item.code, 'surface-0': bank_choosen.code != item.code}"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>


            <!--RECIPIENT FIELDS-->
            <RecipientFields @check_valid="setValidReceipent" @return_fields="setFields"
                :fields="recipient_fields" 
                :requiredFields="recipient_fields_required" 
                :currency="currency_choosen.code"/>
        </div>

        <!--DESCRIPTION-->
        <div v-if="loaded">
            <span class="text-color-secondary">{{ lang('description') }}:</span>
            <Textarea rows="5" cols="20" class="w-full surface-border border-2 border-round-lg text-sm p-2 mt-2 mb-3" 
                :value="description" :placeholder="lang('description_text')"
                @input="description = $event.target.value"
                style="resize: none !important; font-family: inherit;"
                />
        </div>
        <Skeleton v-else height="5rem" class="mt-2 mb-3"/>

        <div class="field w-full">
            <Button @click="create()" :label="lang('button')" class="p-button-lg w-full border-round-lg" :disabled="!check_custom_valid" :loading="isLoading" />
        </div>

    </div>

    <!--ERRORS-->
    <div v-if="totalError">
        <InlineMessage severity="warn" class="border-round-xl">{{ totalErrorMessage }}</InlineMessage>
    </div>
</template>
  
<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { reactive, ref } from 'vue'
import MobMenu from '@/components/sides/menu/MobMenu.vue'
import RecipientFields from '@/components/widgets/RecipientFields.vue'

export default {
    data() {
        return {
            header: {
                en: {name: "Create a bill"} ,
                ru: {name: "Создать счет"} ,
            }, 
            errors: {
                ru: {
                    no_required_data: 'Не хватает данных для создания счета',
                    no_rates: 'В данный момент нет возможности создать счет',
                    no_rates_loaded: 'Не загружены курсы валют',
                    no_currencies_loaded: 'Не загружены валюты',
                    no_banks_loaded: 'Не загружены банки'
                },
                en: {
                    no_required_data: 'There is not enough information to create a bill',
                    no_rates: 'There is no way to create a bill at the moment.',
                    no_rates_loaded: 'Currency rates not loaded',
                    no_currencies_loaded: 'No currencies loaded',
                    no_banks_loaded: 'Banks not loaded'
                }
            },

            amount_send: null,
            min_limit: null,
            max_limit: null,

            rates: [],
            rate_obj: {},
            all_currencies: null,
            currencies: [],
            currency_choosen: null,
            
            recipients: [],
            recipients_allowed: [],
            recipient_choosen: null,
            recipients_popup: false,
            recipients_obj: {},
            hide_recipients: false,

            banks_obj: {},
            banks_list: [],
            bank_choosen: null,
            bank_popup: false,

            isLoading: false,
            submitted: false,
            loaded: false,
            recalculating: false,
            
            totalError: false,
            totalErrorMessage: null,
            description: null,

            countTypes: [
                {
                    title: {
                        ru: 'Многоразовый',
                        en: 'Reusable'
                    },
                    code: 'count'
                },
                {
                    title: {
                        ru: 'Одноразовый', 
                        en: 'One-time'
                    },
                    code: 'one'
                }
            ],
            countType: 'count',

            amountTypes: [
                {
                    title: {
                        ru: 'Клиент',
                        en: 'Client'
                    },
                    code: 'sender'
                },
                {
                    title: {
                        ru: 'Получатель (вы)', 
                        en: 'Recipient (you)'
                    },
                    code: 'recipient'
                }
            ],
            amountType: 'sender',
            
            recipientFieldsValid: false,
            recipientFields: {},

            recipient_fields: [],
            recipient_fields_required: []
        }
    },
    // задаем переменные для валидации
    setup () {
        const react = reactive({
            recalculating_: false,
        })
        return { react }
    },
    components: {
        RecipientFields,
        MobMenu
    },
    computed: {
        lang_() {return (this.$i18n.locale) ? this.$i18n.locale : 'ru'},
        // проверяет все поля на валидность в зависимости от выбранного способа перевода 
        check_custom_valid(){
            // если есть получатель – то не проверяем
            if(this.recipient_choosen) return true
            if(!this.recipientFieldsValid) return false
            return true
        },
    },
    watch: {
        currency_choosen: function (val) {
            if(!val) return
            if(!val.code) return
            if(!this.loaded || this.recalculating) return 
            this.recalculate('currency')
        },
    },
    methods: {
        setValidReceipent(value){
            this.recipientFieldsValid = (value) ? true : false
        },
        setFields(fields){
            this.recipientFields = fields
        },
        lang(value){
            return this.$t(`views.personal.billCreateForm.${value}`)
        },
        recipients_popup_show() {
            this.recipients_popup = true
        },
        networks_popup_show(){
            this.networks_popup = true
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        get_bank_title(code){
            return this.helper.get_bank_title(code, this.$store.state.payment.banks, this.lang_)
        },
        get_bank_image(code){
            return this.helper.get_bank_image(code, this.$store.state.payment.banks)
        },
        getCurImage(cur){
            if(!cur || !cur.image) return ''
            return cur.image
        },
        choose_bank(code){
            this.bank_choosen = this.banks_obj[code]
            this.bank_popup = false
            this.recalculating = true
            this.recalculate('bank_choosen').then(res => {
                this.recalculating = false
            })
        },
        banks_popup_show(){
            this.bank_popup = true
        },
        banks_popup_show(){
            this.bank_popup = true
        },
        // выбор получателя
        async choose_recipient(id) {
            this.recipients_popup = false
            this.recipient_choosen = this.recipients.find(item => item._id == id)
            this.hide_recipients = false
            if(this.recipient_choosen){
                this.account_number = null
                this.card_number = null
                this.fullname = null
                this.phone_number = null
                this.wallet_address = null
                this.telegram = null
            }
        },
        // создание нового получателя
        new_recipient(val){
            if(val){
                this.recipient_choosen = null
                this.hide_recipients = true
            } else {
                this.recipient_choosen = this.recipients[0]
                this.hide_recipients = false
            }
        },
        formatCardNumber(val){
            return this.helper.format_card(val)
        },
        // форматирование списка банков
        formatBankList(array){
            return this.helper.formatBankList(array)
        },
        get_code(obj){
            if(!obj || obj.code == undefined) return ''
            return obj.code
        },
        // расчет
        async recalculate(code = null) {
            console.log('recalculate', code)

            if (!this.rates || !this.all_currencies || !this.banks_list || !this.banks_obj) {
                this.totalError = true
                this.totalErrorMessage = this.errors[this.lang_].no_required_data
                return
            }

            // определяем валюты доступные для приема (from==null)
            if(code=='start' || code=='currency'){
                let currencies_obj = {}
                for (const [k, v] of Object.entries(this.all_currencies)) {
                    for(let i = 0; i < this.rates.length; i++){
                        if(this.rates[i].to == v.code && this.rates[i].from == null) currencies_obj[v.code] = v
                    }
                }
                this.currencies = Object.values(currencies_obj)

                // определяем валюту по умолчанию (если задан или не задан код валюты)
                if(code=='start') this.currency_choosen = this.currencies[0]
                else this.currency_choosen = this.currencies.find(item => item.code == this.currency_choosen.code)

                if(!this.currency_choosen || !this.currency_choosen.code){
                    this.totalError = true
                    this.totalErrorMessage = this.errors[this.lang_].no_rates
                    return
                }

                // определяем курс приема, если нет - ошибка
                this.rate_obj = {}
                for(let i = 0; i < this.rates.length; i++){
                    if((this.rates[i].from == null) && (this.rates[i].to == this.currency_choosen.code)) this.rate_obj = this.rates[i]
                }
                if(!this.rate_obj || !this.rate_obj.send_bank_codes || this.rate_obj.send_bank_codes.length <= 0){
                    this.totalError = true
                    this.totalErrorMessage = this.errors[this.lang_].no_rates
                    return
                }
                
                // определяем минимальную и максимальную сумму приема
                this.min_limit = (this.rate_obj.limits && this.rate_obj.limits.bill && this.rate_obj.limits.bill.min) ? parseFloat(this.rate_obj.limits.bill.min) : 0
                this.max_limit = (this.rate_obj.limits && this.rate_obj.limits.bill && this.rate_obj.limits.bill.max) ? parseFloat(this.rate_obj.limits.bill.max) : 999999999

                // определяем сумму отправки
                if(!this.amount_send){
                    this.amount_send = this.min_limit
                } else {
                    if(this.amount_send < this.min_limit) this.amount_send = this.min_limit
                    if(this.amount_send > this.max_limit) this.amount_send = this.max_limit
                }
            }

            // определяем банки получения
            if(code=='start' || code=='currency'){
                let banks_res = {}
                let raw_banks = Object.values(this.banks_obj)
                for(let j = 0; j < raw_banks.length; j++){
                    if(this.rate_obj.send_bank_codes.includes(raw_banks[j].code)) banks_res[raw_banks[j].code] = raw_banks[j]
                }
                this.banks_list = Object.values(banks_res)
                if(this.banks_list.length > 0) this.bank_choosen = this.banks_list[0]
                else this.bank_choosen = null
            }

            // задаем валидацию
            // this.set_validate(this.bank_choosen)
            this.recipient_fields = this.bank_choosen.recipient_fields
            this.recipient_fields_required = this.bank_choosen.recipient_fields_required

            // определяем список получателей
            let allowed_send_bank_codes = []
            for(let i = 0; i < this.banks_list.length; i++){
                allowed_send_bank_codes.push(this.banks_list[i].code)
            }

            let recipients_obj = {}
            let raw_recipients = Object.values(this.recipients_obj)
            if(raw_recipients.length>0) {
                for(let i = 0; i < raw_recipients.length; i++){
                    if(raw_recipients[i].currency_code == this.currency_choosen.code && allowed_send_bank_codes.includes(raw_recipients[i].bank_code)) recipients_obj[raw_recipients[i]._id] = raw_recipients[i]
                }
            }
            this.recipients_allowed = Object.values(recipients_obj)

            // если есть получатели, то выбираем первого / если нет - null
            if(this.recipients_allowed.length > 0) {
                this.recipient_choosen = this.recipients_allowed[0]
                if(code!='bank_choosen') {
                    this.hide_recipients = false
                } else {
                    this.hide_recipients = true
                    this.recipient_choosen = null
                }
            } else {
                this.recipient_choosen = null
                if(code!='bank_choosen') {
                    this.hide_recipients = true
                } else {
                    this.hide_recipients = true
                    this.recipient_choosen = null
                }
            }
        },
        cleanCardOrPhone(val){
            const clear_num = this.helper.cleanCardOrPhone(val)
            if(typeof(clear_num)=='string') return parseInt(clear_num)
            else return clear_num
        },
        async create(){
            this.isLoading = true 
            this.submitted = true

            if (!this.check_custom_valid) {
                this.isLoading = false
                this.submitted = false
                this.showMess('error', 'error_create', '')
                return
            }

            // если выбран получатель, то берем его id
            const recipient_id = (this.recipient_choosen && this.recipient_choosen._id) ? this.recipient_choosen._id : null

            let amount = null
            if(this.amountType == 'recipient') amount = this.amount_send

            const data = {
                amount: amount,
                recipient_id: recipient_id,
                currency_code: this.get_code(this.currency_choosen),
                bank_code: this.get_code(this.bank_choosen),
                recipient_fields: this.recipientFields,
                count_type: this.countType,
                description: this.description,
            }

            let bill = {}
            try {
                bill = await this.connect.bill_create(data).then(res => res)
                if(bill.result && bill.data) {
                    this.showMess('success', this.lang('success_title'), this.lang('success_subtitle'))
                    this.$router.push({path: '/personal/bills/'})
                } 
                if(bill.errors && bill.errors.length > 0) {
                    for (let i = 0; i < bill.errors.length; i++) {
                        this.showMess('error', this.lang('error_title'), bill.errors[i])
                    }
                }
                this.isLoading = false
                this.submitted = false
            } catch (error) {
                console.log(error)
                this.showMess('error', this.lang('error_title'), this.lang('error_title'))
                this.isLoading = false
                this.submitted = false
            }
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        // валюты | обязательно
        const storeCurrencies = this.$store.getters.GetCurrencies
        if(storeCurrencies && Object.keys(storeCurrencies).length) this.all_currencies = storeCurrencies
        else {
            const resCurrencies = await this.$store.dispatch('GetCurrencies').then(res => res)
            if (!resCurrencies.result || !resCurrencies.data || resCurrencies.data.length <= 0){
                this.totalError = true
                this.totalErrorMessage = 'No currencies loaded'
                return
            }
            this.all_currencies = resCurrencies.data
        }
        // console.log('all_currencies: ', this.all_currencies)

        // банки | обязательно
        const storeBanks = this.$store.getters.GetBanks
        if(storeBanks && Object.keys(storeBanks).length) this.banks_obj = this.helper.formatBankList(storeBanks)
        else {
            const resBanks = await this.$store.dispatch('GetBanks').then(res => res)
            if (!resBanks.result || !resBanks.data || resBanks.data.length <= 0){
                this.totalError = true
                this.totalErrorMessage = 'No banks loaded' // TODO: вывести ошибку на разных языках
                return
            }
            this.banks_obj = this.helper.formatBankList(resBanks.data)
        }
        // console.log('banks_obj: ', this.banks_obj)

        //курсы доступных валют | обязательно
        const rates = await this.connect.GetNulledRates().then(res => res)
        if (!rates.result || !rates.data || rates.data.length <= 0){
            this.totalError = true
            if(rates.errors && rates.errors.length > 0) this.totalErrorMessage = rates.errors[0]
            else this.totalErrorMessage = this.errors[this.lang_].no_rates_loaded
            return
        }
        // проверяем на обязательные поля
        rates.data.forEach(r => {
            if( 
                (r.from || r.to) && 
                r.rate && 
                r.limits &&
                r.get_bank_codes && 
                r.send_bank_codes) {
                this.rates.push(r)
            }
            return true
        })
        console.log('rates: ', this.rates)

        // список получателей
        const recipients = await this.connect.user_recipients('array').then(res => res)
        if (recipients.result && recipients.data && recipients.data.length > 0) {
            this.recipients = recipients.data
            this.recipients_obj = {}
            for(let i = 0; i < this.recipients.length; i++){
                this.recipients_obj[this.recipients[i]._id] = this.recipients[i]
            }
        }

        this.loaded = true
        this.recalculating = true
        this.recalculate('start').then(res => {
            this.recalculating = false
        })
    },
}
</script>